import type { State } from 'src/store/types';
import type { SelectDropdownOption } from 'src/library/editors/elements/select-dropdown-option';
import { employeesShortNamesAndMe } from 'src/store/selectors/employees/employees-short-names-and-me';
import { getContactsAsUsers } from 'src/store/selectors/partners/get-contacts-as-users';
import { employeesShortNamesAndI } from 'src/store/selectors/employees/employees-short-names-and-i';
import { employeesShortNames } from './employees/employees-short-names';

export function userNamesAndI(state: State): SelectDropdownOption[] {
  const employees = employeesShortNamesAndI(state).map((e) => {
    return { value: e.uuid, text: e.name };
  });
  const contacts = getContactsAsUsers(state).map((p) => {
    return { value: p.uuid, text: p.name + ' (' + p.partnerName + ')' };
  });
  return employees.concat(contacts);
}
export function userNamesAndMe(state: State): SelectDropdownOption[] {
  const employees = employeesShortNamesAndMe(state).map((e) => {
    return { value: e.uuid, text: e.name };
  });
  const contacts = getContactsAsUsers(state).map((p) => {
    return { value: p.uuid, text: p.name + ' (' + p.partnerName + ')' };
  });
  return employees.concat(contacts);
}
export function userNames(state: State): SelectDropdownOption[] {
  const employees = employeesShortNames(state).map((e) => {
    return { value: e.uuid, text: e.name };
  });
  const contacts = getContactsAsUsers(state).map((p) => {
    return { value: p.uuid, text: p.name + ' (' + p.partnerName + ')' };
  });
  return employees.concat(contacts);
}
